document.addEventListener("DOMContentLoaded", function () {

  function getCurrencySymbol() {
    var el = document.getElementById("money-format");
    if (!el) return "";

    // Extract symbol (remove numbers)
    return el.innerText.replace(/[0-9.,\s]/g, '');
  }

  function formatMoney(cents) {
    var symbol = getCurrencySymbol();
    var amount = (cents / 100).toFixed(2);
    return symbol + amount;
  }

  function updateBadge(variant) {
    var badge = document.querySelector(".mybadge");

    if (!badge || !variant) return;

    var comparePrice = variant.compare_at_price;
    var price = variant.price;

    // Hide if no sale
    if (!comparePrice || comparePrice <= price) {
      badge.style.display = "none";
      return;
    }

    var savings = comparePrice - price;
    var formattedSavings = formatMoney(savings);

    badge.style.display = "block";
    badge.innerHTML = `
      <span class="custom-sale-badge">
        <span class='micon'>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <image xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAs0lEQVR4AYSQPw4BQRyFl7gDtQiFWkP8KSQu4BJu4V40BIVSIZGgXqfg+zZWNmuYzXuZt7953+xmqkn4qTM+4mfBZ/I8BFjesNnDucaEBV6WgQbDHe7gsmoMukXAk/cMW7gsv7h2mAOWDwya+K8E/I0trWiZzklgRWjjmC4UZgIVQkyWJ5RSgSnhin/pzobXmrImAoYhLyHIcp+9B84kYAhBX2WLOWAWGhFubw9YPyeTM70AAAD//zqMKTMAAAAGSURBVAMAeLIhAryivawAAAAASUVORK5CYII=" x="0" y="0" width="12" height="12"/>
          </svg>
        </span>
        SAVE ${formattedSavings}
      </span>
    `;
  }

  document.addEventListener("variant:change", function (event) {
    updateBadge(event.detail.variant);
  });

});